export const minorDiseases = [
  {checked: false, key: 'THYROID_ACTIVITY',  label: 'פעילות בלוטת התריס', chosenTravelers: []},
  {checked: false, key: 'ADHD',              label: 'הפרעות קשב וריכוז',  chosenTravelers: []},
  {checked: false, key: 'CHOLESTEROL',       label: 'כולסטרול',           chosenTravelers: []},
  {checked: false, key: 'ALERGY',            label: 'אלרגיה',             chosenTravelers: []},
  {checked: false, key: 'MIGRAINE',          label: 'מיגרנה',             chosenTravelers: []},
  {checked: false, key: 'ULCER',             label: 'אולקוס',             chosenTravelers: []},
  {checked: false, key: 'HEARTBURN',         label: 'צרבת',               chosenTravelers: []},
  {checked: false, key: 'GASTRIC_ULCER',     label: 'כיב קיבה',           chosenTravelers: []},
]